<template>
    <div>
    <v-card class="bg-card mb-2">
        <v-card-text class="px-0 pt-0 pb-0">
    
            <LocalTable :model="model" modelLinesProp='appointments' editable ref="appointments" no-hover dense :dt="tblLines">
                <template v-slot:menu ="{ item }">
                    <ActionMenuItem icon="edit" :model="model" action="workorder_appointment.open" @click="()=>onOpenAppointment(item)">Open afspraak</ActionMenuItem>
                    <v-divider></v-divider>
                    <ActionMenuItem v-if="canUnlockAppointment(item)" :model="model" action="workorder.modify" icon="unlock" @click="tblLines.onStartCheckBox(item, 'unlock')">Zet afspraak terug naar 'Werkvloer'</ActionMenuItem>
                    <v-divider v-if="canUnlockAppointment(item)"></v-divider>
                    <ActionMenuItem :model="model" action="workorder.modify" icon="remove" @click="tblLines.onStartCheckBox(item, 'remove')">Verwijder afspraak</ActionMenuItem>
                </template>
                <template v-slot:commands ="{dt, bulkAction, selectedCount}">
                    <ActionButton main primary icon="remove" v-if="dt.bulkAction=='remove'"  @click="()=>onBulkRemoveAppointments()" :disabled="!dt.selectedCount" >Verwijder</ActionButton>
                </template>

                <template v-slot:bottom-commands="{/*dt, hasCmd, */columnHeaders}">
                    <v-divider></v-divider>
                    <div class="pa-4 pb-2">
                        <ActionButton sub action="workorder.modify" dusk="btn-add-line" :model="model" icon="add" @click='(evt)=>addAppointment(evt)'>Nieuwe afspraak</ActionButton>
                    </div>
                </template>
                
                <template v-slot:item.finished_at ="{ item }">
                    <span class="cursor-pointer" @click='()=>onOpenAppointment(item)'>                        
                        <StatusChip type="appointment" :model="{id_status: statusValue(item)}"></StatusChip>
                    </span>
                </template>

                <template v-slot:item.note ="{ item }">
                    <span class="cursor-pointer" style="position:relative;top:-2px;">
                        <Icon :type="item.note?'note':'noteempty'" :color="item.note?'warning':''"></Icon>
                    </span>

                </template>
                <template v-slot:item.signed_by ="{ item }">
                    <span v-if="!item.signed_by">-</span>
                    <span v-else class="text-primary cursor-pointer" @click="()=>onOpenSignature(item)">
                        <span class="">{{item.signed_by}}</span>
                    </span>
                        
    
                </template>

                <template v-slot:customcommands="{bulkAction, selectedCount}">
                    <ActionButton main primary icon="unlock" v-if="bulkAction=='unlock'"  @click="onBulkUnlockAppointment" :disabled="!selectedCount" >Terug naar 'Werkvloer'</ActionButton>
                </template>

                
            </LocalTable>
        </v-card-text>
    </v-card>

    <v-row dense class="mt-2 appointment-details" v-if="selectedRow">
        <v-col>
            <v-card class="bg-card appointment-note">
                <v-card-title>Werknotitie <span class="text-small ml-4">{{ selectedRow?.employee_name }}</span> 
                <v-spacer></v-spacer>
                    <span v-if="selectedRow.isEditable">
                        <ActionButton :loading="selectedRow.isSaving" success icon="save" :model="model" action="workorder.modify" @click="onSaveNote"></ActionButton>
                        <ActionButton icon="close" ml :model="model" action="workorder.modify" @click="onCancelSaveNote"></ActionButton>
                    </span>
                    <span v-else>
                        <ActionButton main primary icon="edit" :model="model" action="workorder.modify" @click="onStartEditNote"></ActionButton>                        
                    </span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <TextArea :disabled="!selectedRow.isEditable" class="bordered w-100" placeholder="Geen werknotitie" v-model="selectedRow.note"></TextArea>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col>
            <v-card dense class="bg-card appointment-note-internal">
                <v-card-title>Interne notitie <span class="text-small ml-4">{{ selectedRow?.employee_name }}</span> </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <TextArea disabled class="bordered w-100" placeholder="Geen interne notitie" v-model="selectedRow.note_internal"></TextArea>
                </v-card-text>
            </v-card>            
        </v-col>
        <v-col>
            <v-card dense class="bg-card appointment-attachments">
                <v-card-title>Bijlagen<span class="text-small ml-4">{{ selectedRow?.employee_name }}</span> </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="attachment-wrapper">
                    <v-row dense>
                        <v-col sm="auto" v-for="(att, i) in selectedRow.attachments" :key="i">
                            <v-card>
                                <v-card-text class="pa-2">
                                    <div class="image-wrapper position-relative">
                                        <img  class="bg-card cursor-pointer" @click="onOpenAttachment(att)" :src="att.url" alt="Bijlage"/>
                                        <span @click="()=>onRemoveAttachment(att)" class="radius-50 position-absolute inline-flex v-center h-center pa-2 cursor-pointer" style="bottom:-2px;right:-4px;background-color:white; width:32px;height:32px;">
                                            <Icon color="primary" size="xs" type="remove" class="v-center"></Icon>
                                        </span>
                                    </div>
                                </v-card-text>
                            </v-card>                            
                        </v-col>
                        <v-col v-if="!selectedRow?.attachments?.length" class="">
                            <span class="text-secondary">Er zijn geen bijlagen toegevoegd.</span>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>                        
        </v-col>
    </v-row>

</div>        
</template>



<script setup>

import ActionButton from '@shared/ui/controls/buttons/ActionButton'
import LocalTable from '@datatable/LocalTable'  
import clsLocalTable from '@cls/clsLocalTable'
import ActionMenuItem from "@controls/menu/ActionMenuItem.vue";
import {computed, ref, vue, nextTick, watch} from 'vue'
// import StatusChip from "@controls/widgets/StatusChip.vue";
import StatusChip from '@/features/workorders/workorder/controls/StatusChip'

import Icon from '@controls/icons/Icon'
import TextArea from '@controls/input/TextArea'
import dlg from '@app/dlg'
import Constants from '@app/consts'

import noty from '@shared/lib/noty'
import eventbus from '@app/eventbus'

const selectedRow = ref(null)

const props = defineProps({
    model: {
        type: [Object]
    },
    invTriggerCnt: {
        type: [Number, String]
    }
});
const emit = defineEmits(['onCreateInvoice', 'save'])

let headers = [

    { canhide: false, canmove: false, type: 'cmd'}, 
    { text: "",      value: "note",  class: "w-0_5", cellClass:'pr-2' }, 
    { text: "Medewerker",      value: "employee_name",    type: 'open', open: 'workorder_appointment', class: "", }, 
    { text: "Dag",             value: "dt",               type: 'dow', class: "w-4", }, 
    { text: "Afspraak",        value: "dt",               type: 'date', class: "w-4", }, 
//    { text: "Tijdsduur",      value: "duration",         type: 'duration', class: "", }, 
//    { text: "Afspraken",      value: "appointments",     type: 'count', class: "", },
    { text: "Van",             value: "from",             type: 'hhmm', class: "w-2", }, 
    { text: "Tot",             value: "to",               type: 'hhmm', class: "w-2", }, 
    { text: "Status",          value: "finished_at",      class: "", }, 
    { text: "Gereedgemeld op", value: "finished_at",      type: 'datetime', class: "", }, 
    { text: "Handtekening",    value: "signed_by",        nofmt: (v) => !!v?v:'-', }, 

    { text: "Aangemaakt op",   value: "created_at",       class: "", }, 
    { visible: false, text: "Gewijzigd op",    value: "updated_at",       class: "", }, 
    { visible: false, text: "Aangemaakt door", value: "created_by",       class: "", }, 
    { visible: false, text: "Gewijzigd door",  value: "updated_by",       class: "", }, 

];

var statusValue = function(item) {
    if (!!item.finished_at) {
        return Constants.workorder.status.STATUS_EXECUTED;
    }
    if (!item.employee_visible) {
        return Constants.workorder.status.STATUS_PLANNED;
    }
    return Constants.workorder.status.STATUS_EXECUTING;
}
var statusRep = function(item) {
    switch (statusValue(item)) {
        case Constants.workorder.status.STATUS_PLANNED: return "Ingepland"
        case Constants.workorder.status.STSTATUS_EXECUTING: return "Werkvloer"
        case Constants.workorder.status.STATUS_EXECUTED: return "Gereed"
    }
    return "Gereed";
}


var setAppointmentDetails = function(idAppointment) {
    idAppointment ||= idAppointment = selectedRow.value?.id;
    if (!idAppointment) {
        return; 
    }
    var row = props.model.getDetailsForAppointment(idAppointment);
    if (!row) {
        selectedRow.value = null;
        return;
    }
    row.isEditable = false; 
    row.isSaving = false; 
    selectedRow.value = row;
}
var onClickAppointment = function(evt, item) {    
    if (!item) {
        selectedRow.value = null;
        return;
    }   
    setAppointmentDetails(item.id);
}

var onStartEditNote = function() {
    if (!selectedRow.value) {
        return; 
    }
    selectedRow.value.isEditable = true;
}
var onCancelSaveNote = function() {
    setAppointmentDetails();
}

var onSaveNote = async function() {
    selectedRow.value.isSaving = true;
    try {
        await props.model.saveAppointmentNote(selectedRow.value.id, selectedRow.value.note);     
    } finally {
        selectedRow.value.isSaving = false;
    }
    setAppointmentDetails();
}

let tblLines = ref(new clsLocalTable("workorder.appointments", headers, {
    noDataText: "Er zijn nog geen afspraken toegevoegd",
    noSort: true,
    model: props.model, 
    modelLinesProp: 'appointments',   
    actionClick: onClickAppointment, 
}));

async function addAppointment(){
    try {
        var dt = props.model.target_at;
        var estimate = props.model.estimate;

        let selected = await dlg.promised.create("workorder_createappointment", {dt:dt, estimate:estimate});
        props.model.createAppointment(selected)
    }
    catch (e) { /* canceled */}
}

function onBulkRemoveAppointments(line) {
    var ids = tblLines.value.selectedIDs(); 
    props.model.removeAppointments(ids);
}

// Can the appointment be unlocked? 
// Yes when workorder status is either [ planned, executing or executed] and the finished_at field of the appointment is set. 
function canUnlockAppointment(item) {
    if (!item?.finished_at) {
        return false;
    }
    switch (props.model.id_status) {
        case Constants.workorder.status.STATUS_PLANNED:
        case Constants.workorder.status.STATUS_EXECUTING:
        case Constants.workorder.status.STATUS_EXECUTED:
            return true;
    }
    return false;     
}
async function onBulkUnlockAppointment(line) {
    if (!await noty.tryConfirm("Weet je zeker dat je deze afspraken weer terug wilt zetten naar 'Werkvloer'?<br>Deze afspraken kunnnen dan in de app opnieuw bewerkt worden door de medewerker.<br><br>Eventuele handtekeningen worden verwijderd.")) {
        return;
    }
    var ids = tblLines.value.selectedIDs(); 
    props.model.unlockAppointments(ids);
    tblLines.value.onStopCheckbox();
    eventbus.model.stats.refresh('workorder');

}



async function onOpenAppointment(line) {
    var result = await dlg.promised.tryOpen('workorder_appointment', {id: line.id});
    if (result) {
        props.model.updateAppointments(result);
    }
}
async function onOpenSignature(line) {
    var result = await dlg.promised.tryOpen('workorder_signature', {id: line.id});
    if (result) {
        props.model.updateAppointments(result);
    }
}

async function onOpenAttachment(line) {
    dlg.image({
        files: selectedRow.value.attachments,
        selectedUrl: line.url,
    });
}

async function onRemoveAttachment(att) {
    if (!await noty.tryConfirm("Weet je zeker dat je deze bijlage wilt verwijderen?")) {
        return;
    }
    await props.model.removeAttachments([att.id]);
    setAppointmentDetails();
}

</script>